import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import TextArea from "../../components/TextArea";
import Button from "../../components/Button";
import InputField from "../../components/InputField";
import { ADMIN_API_BASE } from "../../utils/apiConfig";

const AdminSendMail = () => {

    const [emailBody, setEmailBody] = useState('');
    const [to, setTo] = useState('');
    const [subject, setSubject] = useState('');

    const handleOnChangeBody = (e) => {
        setEmailBody(prevState => e.target.value);
    }

    const handleOnChangeSubject = (e) => {
        setTo(prevState => e.target.value);
    }

    const handleOnChangeTo = (e) => {
        setEmailBody(prevState => e.target.value);
    }

    const handleButtonClick = async () => {
        try {
            const token = getCsrfToken();

            const data = {to: 'info@code-pro.ir', subject: 'Test', 'text': '<p>Test!</p>'};

            let response = await axios.post(`${ADMIN_API_BASE}/mail/`, data, {
                headers: {
                    'csrf-token': token,
                },
                withCredentials: true
            });

            if (response.success) {

            } else {
            }

        } catch
            (e) {
            console.log(e);
        }
    }


    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='خرید ها'/>
                        <div className='w-full flex gap-4 py-3 px-10 flex-1 my-10'>
                            <form className='w-100 flex-col flex px-8 py-5'
                                  onSubmit={(e) => e.preventDefault()}>
                                <InputField type='text' title='به ایمیل' name='to' onChange={handleOnChangeTo} value={to} />
                                <InputField type='text' title='موضوع' name='subject' onChange={handleOnChangeSubject} value={subject} />
                                <TextArea title='متن ایمیل' name='email-body' value={emailBody}
                                          onChange={handleOnChangeBody}/>
                                <Button onClick={handleButtonClick}>ارسال</Button>
                            </form>
                        </div>
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminSendMail;
